import React from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";

import breakthrough_energy from "assets/img/investors/breakthrough-energy.png";
import grit_capital from "assets/img/investors/grit-capital.png";
import material_impact from "assets/img/investors/material-impact.svg";
import moai_capital from "assets/img/investors/moai-capital.png";
import stage_1_ventures from "assets/img/investors/stage-1-ventures.jpg";
import genlab_studio from "assets/img/investors/genlab-logo.svg";

const investors = [
  {
    link: 'https://breakthroughenergy.org/',
    imageSrc: breakthrough_energy,
  },
  {
    link: 'https://www.materialimpact.com/',
    imageSrc: material_impact,
  },
  {
    link: 'https://grit.vc/',
    imageSrc: grit_capital,
  },
  {
    link: 'https://www.stage1ventures.com/',
    imageSrc: stage_1_ventures,
  },
  {
    link: 'https://www.moai.vc/',
    imageSrc: moai_capital,
  },
  {
    link: 'https://genlab.studio/',
    imageSrc: genlab_studio,
  },
];

const Investors = () => {
  document.documentElement.classList.remove("nav-open");

  return (
    <div className="section section-maglev-blue-dark text-center">
      <Container>
        <h1 className="title" style={{ color: 'white', fontWeight: 'bolder'}}>Investors</h1> 
        <Row className="justify-content-center">
          <Col md="10" className="mb-5">
            <div style={{ padding: '10px', borderRadius: '10px' }}>
              <Row className="justify-content-center">
                {investors.map((article, index) => (
                  <Col key={index} lg="4" md="4" sm="4" xs="6" className="mb-3">
                    <a href={article.link} target="_blank" rel="noopener noreferrer">
                      <div
                        style={{
                          width: '100%',
                          height: '120px',
                          borderRadius: '10px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          src={article.imageSrc}
                          alt={`Investor ${index}`}
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                      </div>
                    </a>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
        <p style={{ color: 'white', fontSize: '1.5em' }}>
          Interested in investing in the future of flight?&nbsp;
          <a href={'mailto:contact@maglevaero.com'} target="_blank" style={{textDecoration:'underline'}}>
            Email&nbsp;Us!
          </a>
        </p>
      </Container>
    </div>
  );
}

export default Investors;
